<!--
 * @Author: cmchiu
 * @Date: 2023-03-21 15:48:21
 * @LastEditTime: 2023-06-08 14:25:51
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\layout\AppFooter\appFooter.vue
 * 
-->
<template>
    <div class="app-footer">
        <!-- Footer -->
        <footer class="footer w-100">
            <div class="container">
                <div class="footer__content d-flex justify-content-between">
                    <img class="footer__logo" src="images/logo.svg" alt="" />
                    <div class="footer__text d-flex justify-content-between">
                        <div class="footer__info">
                            <h2 class="footer__title">中國文化大學研究發展處</h2>
                            <p class="footer__contact">
                                學校地址：台北市士林區華岡路55號<br />
                                聯絡電話：(02)2861-0511
                            </p>
                            <p class="footer__copyright">© 2023 中國文化大學產學合作媒合平台 All rights reserved.</p>
                        </div>
                        <ul class="footer__link d-flex flex-wrap align-content-start">
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/about/Page', query: { id: '0800' } }">
                                    關於我們
                                </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/research-develop/result', query: { id: '0130' } }">
                                    研發技轉公告
                                </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/TeacherSearch' }"> 教師專業 </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/InstrumentSearch' }"> 貴重儀器設備 </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/ProjectSearch' }"> 研究產學計畫 </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/news/NewsList', query: { id: '0500' } }">
                                    產學新聞
                                </router-link>
                            </li>
                            <li class="footer__link-item">
                                <router-link :to="{ path: '/regulation/download', query: { id: '0610' } }">
                                    法規表單
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'appFooter',

    data() {
        return {}
    },

    methods: {},
}
</script>
